import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Input from "../common/Input";
import { censusGroupPlanAction } from "../services/soar";

function GroupPlanModal({
  isOpen,
  handleClose,
  groupPlan,
  setGroupPlan,
  updateGroupPlans,
}) {
  const handleSave = async () => {
    groupPlan.command = groupPlan.id ? "update" : "insert";
    const resp = await censusGroupPlanAction(groupPlan);
    if (resp.code === "success") {
      updateGroupPlans();
      handleClose();
    } else {
      toast.warning(
        `There was a problem with saving Group Plan. ${resp.message}`
      );
    }
  };

  return (
    <Modal show={isOpen} onHide={handleClose} animation={false} size="lg">
      <Modal.Header closeButton className="bg-safy-info text-white">
        <Modal.Title>Group Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <Input
            name="name"
            label="Group Plan Name"
            value={groupPlan.name || ""}
            onChange={(e) => {
              setGroupPlan({ ...groupPlan, name: e.target.value });
            }}
          />
        </div>
        <div className="row">
          <Input
            type="date"
            name="effective"
            label="Effective Date"
            value={groupPlan.effective || ""}
            onChange={(e) => {
              setGroupPlan({
                ...groupPlan,
                effective: e.target.value,
              });
            }}
          />
        </div>
        <div className="row">
          <Input
            type="date"
            name="expiration"
            label="Expiration Date"
            value={groupPlan.expiration || ""}
            onChange={(e) => {
              setGroupPlan({
                ...groupPlan,
                expiration: e.target.value,
              });
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="btn btn-danger" onClick={handleClose}>
          Close
        </div>
        <div
          className="btn btn-success"
          onClick={() => {
            handleSave();
          }}
        >
          Save
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default GroupPlanModal;
